<template>
  <transition name="nav-fade">
    <div
      v-if="isUndecided"
      data-test="analytics-consent-banner"
      class="fixed inset-x-0 bottom-0 z-toast p-3 sm:p-4"
      role="region"
      :aria-label="t('analytics_consent.aria_label')"
    >
      <div
        class="mx-auto flex max-w-3xl flex-col gap-3 rounded-xl border border-theme-border bg-theme-surface/95 p-4 shadow-theme-dialog backdrop-blur
          sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="min-w-0">
          <p class="text-sm font-semibold text-theme-text">
            {{ t('analytics_consent.title') }}
          </p>
          <p class="mt-1 text-xs leading-snug text-theme-text-muted">
            {{ t('analytics_consent.body') }}
            <a
              v-if="privacyHref"
              :href="privacyHref"
              class="underline underline-offset-2 hover:text-theme-text"
            >
              {{ t('analytics_consent.privacy_link') }}
            </a>
            <router-link
              v-else
              :to="{ name: 'privacy-statement' }"
              class="underline underline-offset-2 hover:text-theme-text"
            >
              {{ t('analytics_consent.privacy_link') }}
            </router-link>
          </p>
        </div>
        <div class="flex flex-shrink-0 items-center gap-2">
          <app-button
            data-test="analytics-consent-decline"
            variant="ghost"
            size="sm"
            @click="decline"
          >
            {{ t('analytics_consent.decline') }}
          </app-button>
          <app-button
            data-test="analytics-consent-accept"
            tone="primary"
            size="sm"
            @click="accept"
          >
            {{ t('analytics_consent.accept') }}
          </app-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import AppButton from '@/components/ui/buttons/AppButton.vue';
  import { useAnalyticsConsent } from '@/composables/useAnalytics';

  // The website has no portal router; it passes its privacy statement URL instead.
  defineProps({ privacyHref: { type: String, default: '' } });
  const { t } = useI18n();
  const { consent, grant, deny } = useAnalyticsConsent();

  // Only prompt when the user has not yet decided (null). Once granted/denied
  // the banner stays hidden; the choice can be changed from the privacy page.
  const isUndecided = computed(() => consent.value !== 'granted' && consent.value !== 'denied');

  function accept() {
    grant();
  }

  function decline() {
    deny();
  }
</script>
